// @flow

// Vendors
import React from 'react';

// Components
import { FormField } from '..';

// Types
type Props = {
  options: Array<{ label: string, value: string }>,
  parentFieldName: string,
  onChange: Function,
  setValue: Function,
  values: Object
};

const CheckboxList = ({
  options,
  parentFieldName,
  values,
  onChange,
  setValue,
  ...props
}: Props) => {
  const handleChange = option => {
    if (!values[parentFieldName].includes(option.value))
      setValue(parentFieldName, [...values[parentFieldName], option.value]);
    else
      setValue(
        parentFieldName,
        values[parentFieldName].filter(value => value !== option.value)
      );
  };

  return (
    <div className="checkbox-list">
      {options.map(option => (
        <FormField
          {...props}
          key={option.value}
          name={`${parentFieldName}${option.value}`}
          label={option.label}
          type="checkbox"
          onChange={() => handleChange(option)}
          checked={values[parentFieldName].includes(option.value)}
        />
      ))}
    </div>
  );
};

export default CheckboxList;
